import React from "react";
import { Link } from "react-router-dom";
import { LOGO_URL, SERVICES, BRANCHES, PHONE, PHONE_DISPLAY, EMAIL, HOURS, ColorBar, RegMark } from "@/components/brand";

export default function Footer() {
  return (
    <footer data-testid="footer" className="bg-ink text-paper">
      <ColorBar onInk />
      <div className="mx-auto max-w-page px-4 sm:px-6 lg:px-10 py-16 md:py-20">
        <div className="grid gap-12 md:grid-cols-2 lg:grid-cols-[1.2fr_1.6fr_0.8fr_1.2fr]">
          <div>
            {/* Logo sits on a paper plate so its colours print true on the ink background */}
            <Link to="/" className="inline-block bg-paper px-4 py-3 rounded-[3px]" aria-label="Print Xpress home">
              <img src={LOGO_URL} alt="Print Xpress" className="h-9 w-auto" />
            </Link>
            <p className="mt-6 text-paper/70 leading-relaxed max-w-xs">
              Printing for Bengaluru's businesses, events and homes since 2002.
            </p>
            <div className="mt-6 space-y-1.5 font-display">
              <a href={`tel:+${PHONE}`} data-testid="footer-phone" className="block text-lg font-semibold hover:text-process-yellow transition-colors">{PHONE_DISPLAY}</a>
              <a href={`mailto:${EMAIL}`} className="block text-paper/80 hover:text-process-yellow transition-colors">{EMAIL}</a>
              <p className="text-paper/60 text-sm pt-1">{HOURS}. Closed Sundays.</p>
            </div>
          </div>

          <div>
            <h2 className="font-display font-semibold text-paper/60 text-sm mb-4">What we print</h2>
            <ul className="grid grid-cols-2 gap-x-6 gap-y-2">
              {SERVICES.map((s) => (
                <li key={s.slug}>
                  <Link to={`/services/${s.slug}`} className="text-paper/85 hover:text-paper hover:underline underline-offset-4">{s.name}</Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h2 className="font-display font-semibold text-paper/60 text-sm mb-4">Print Xpress</h2>
            <ul className="space-y-2">
              <li><Link to="/about" className="text-paper/85 hover:text-paper hover:underline underline-offset-4">About us</Link></li>
              <li><Link to="/corporate-gifting" className="text-paper/85 hover:text-paper hover:underline underline-offset-4">Corporate gifting</Link></li>
              <li><Link to="/contact" className="text-paper/85 hover:text-paper hover:underline underline-offset-4">Contact</Link></li>
              <li><Link to="/contact#quote" className="text-paper/85 hover:text-paper hover:underline underline-offset-4">Get a quote</Link></li>
            </ul>
          </div>

          <div>
            <h2 className="font-display font-semibold text-paper/60 text-sm mb-4">Branches</h2>
            <ul className="space-y-5">
              {BRANCHES.map((b) => (
                <li key={b.name}>
                  <a href={b.map} target="_blank" rel="noopener noreferrer" className="group block">
                    <span className="font-display font-semibold text-paper group-hover:text-process-yellow transition-colors">{b.name}</span>
                    <span className="block text-sm text-paper/60 leading-relaxed mt-0.5">{b.address}</span>
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>

      <div className="border-t border-paper/15">
        <div className="mx-auto max-w-page px-4 sm:px-6 lg:px-10 py-6 flex flex-col sm:flex-row sm:items-center justify-between gap-3 text-sm text-paper/50">
          <p>© {new Date().getFullYear()} Print Xpress, a unit of Gurubal Engineering Co. Pvt. Ltd.</p>
          <div className="flex items-center gap-4">
            <Link to="/admin/login" className="hover:text-paper">Staff sign in</Link>
            <RegMark size={18} className="text-paper/30" />
          </div>
        </div>
      </div>
    </footer>
  );
}
